// The app shell's three layouts and what its primary navigation holds. Pure:
// no DOM, so the same rules the shell draws from are tested in Node.
//
// The breakpoints are mirrored in base.css's media queries (a custom property
// can't be read inside a media query, so the numbers are written there too).
// They follow the iPhone and iPad (docs/designs/responsive-web.md):
//
//   1024 and wider  the sidebar, as it always was
//   768 to 1023     an iPad's portrait width: the sidebar is hidden behind a
//                   button in the top bar and slides over the page
//   360 to 767      an iPhone's: a tab bar along the bottom, the account
//                   button at the top left, large titles
//
// Below 360 the app stops shrinking (body's min-width) and the page scrolls
// sideways instead: 360 is the narrowest phone Sendinvo supports.

export const APP_MIN_WIDTH = 360;
export const TABLET_MIN_WIDTH = 768;
export const DESKTOP_MIN_WIDTH = 1024;

// The media queries the shell's JavaScript listens to, written once.
export const OVERLAY_SIDEBAR_QUERY = `(max-width: ${DESKTOP_MIN_WIDTH - 1}px)`;
export const TAB_BAR_QUERY = `(max-width: ${TABLET_MIN_WIDTH - 1}px)`;

export function shellLayoutAt(width) {
  if (width >= DESKTOP_MIN_WIDTH) return "sidebar";
  if (width >= TABLET_MIN_WIDTH) return "overlay";
  return "tabbar";
}

// The primary destinations, in the iPhone's tab order (MainTabs.swift): with
// jobs on Schedule, Invoices, Jobs, Quotes, Clients; without, Invoices,
// Quotes, Clients. The sidebar and the tab bar are both drawn from this, so
// they can't disagree about what is there or in what order.
const SCHEDULE = { route: "schedule", path: "/schedule", label: "Schedule", icon: "calendar" };
const INVOICES = { route: "invoices", path: "/invoices", label: "Invoices", icon: "arrow.down.left" };
const JOBS = { route: "jobs", path: "/jobs", label: "Jobs", icon: "wrench.and.screwdriver" };
const QUOTES = { route: "quotes", path: "/quotes", label: "Quotes", icon: "doc-text" };
const CLIENTS = { route: "contacts", path: "/contacts", label: "Clients", icon: "person.crop.rectangle.stack" };

export function primaryNavItems({ jobs = false } = {}) {
  return jobs ? [SCHEDULE, INVOICES, JOBS, QUOTES, CLIENTS] : [INVOICES, QUOTES, CLIENTS];
}

// The destination a route sits under: recurring invoices are inside Invoices
// (#1022), so /schedules keeps Invoices selected.
export function navRouteFor(activeRoute) {
  return activeRoute === "schedules" ? "invoices" : activeRoute;
}
